import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export function ShowImageDialog({
  data,
  dialog,
  toggleDialog,
  downloadTimer,
  imageName,
}) {
  return (
    <Dialog open={dialog} onClose={toggleDialog}>
      <DialogTitle>View Image</DialogTitle>
      <DialogContent>
        <img src={data} style={{ maxWidth: "100%" }} alt="sample" />
        <DialogContentText>{imageName}</DialogContentText>
        <Button
          variant="contained"
          size="small"
          disabled={downloadTimer ? false : true}
          sx={{ mr: "30px" }}
        >
          <a
            download={imageName}
            href={data}
            style={{
              color: "white",
              textDecoration: "none",
            }}
          >
            {downloadTimer ? "download" : "loading"}
          </a>
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleDialog}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
